import React from "react";

export type TMistralIconProps = React.SVGAttributes<SVGElement>;

export function MistralIcon({ ...rest }: TMistralIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clip-path="url(#clip0_5715_15)">
        <path d="M6.85577 3.5H3.42773V6.89618H6.85577V3.5Z" fill="#FFD800"/>
        <path d="M20.5696 3.5H17.1416V6.89618H20.5696V3.5Z" fill="#FFD800"/>
        <path d="M10.2838 6.896H3.42773V10.2922H10.2838V6.896Z" fill="#FFAF00"/>
        <path d="M20.5699 6.896H13.7139V10.2922H20.5699V6.896Z" fill="#FFAF00"/>
        <path d="M20.57 10.292H3.42773V13.688H20.57V10.292Z" fill="#FF8205"/>
        <path d="M6.85577 13.689H3.42773V17.0851H6.85577V13.689Z" fill="#FA500F"/>
        <path d="M13.7129 13.689H10.2849V17.0851H13.7129V13.689Z" fill="#FA500F"/>
        <path d="M20.5696 13.689H17.1416V17.0851H20.5696V13.689Z" fill="#FA500F"/>
        <path d="M10.2862 17.0869H0V20.4831H10.2862V17.0869Z" fill="#E10500"/>
        <path d="M24 17.0869H13.7139V20.4831H24V17.0869Z" fill="#E10500"/>
      </g>
      <defs>
        <clipPath id="clip0_5715_15">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}
